/***
 * 创建人：李珊
 * 时间：2023-8-16
 * 描述：知识库管理：分页查询 新增 重命名 删除操作
 * 更新说明:
 */
import { PlatformLocation } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SetAttrsComponent } from '../set-attrs/set-attrs.component';
import { GetInstanceComponent } from '../get-instance/get-instance.component';
declare var $;

@Component({
  selector: 'app-machine-learning-query',
  templateUrl: './machine-learning-query.component.html',
  styleUrls: ['./machine-learning-query.component.css']
})
export class MachineLearningQueryComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;
  @ViewChild("batchModal") batchModal: SwModalframeComponent;
  // 知识库名称
  keyword = '';
  // 表格数据
  datas: any = [];
  // 当前选中的数据
  selectedData: any = [];
  // 是否显示加载中
  isLoading: boolean = false;
  // 表格分页组件
  pageBase: any = {
    current: 1,
    size: 10
  }
  // 表格操作按钮
  toolbarArr = [
    ["S28_MA0804", "S28_MA0805", "S28_MA0806"],
    ["S28_MA0801", "S28_MA0802", "S28_MA0803"],
  ];
  toolbar = [[], []];
  operationType = "";
  batchData: any = {};
  modelVer = '1';
  modelName = '';
  // 概念模型树，默认不可选中的父级概念结点
  readonlySelfIds = [];
  // 概念模型树数据
  ontologyTreeDatas = [];
  constructor(
    private location: PlatformLocation,
    private jwt: SwJwtService,
    private http: SwHttpClientService,
    private box: SwMassageBoxService,
    private kmsService: KmsService,
    private create: SwCreateModalComponentService
  ) { }

  ngOnInit() {
    // 查询工具按钮列表
    this.queryToolbarBtns();
    // 表格数据初始化
    this.handleSelectClick();
    this.getOnlogyTreePageList();
  }

  // 查询工具按钮列表
  queryToolbarBtns() {
    // 根据路径去查询配置的按钮
    let pathname = ["/", "", ""]
    try {
      pathname = this.location["location"].hash.split('?')[0].split("/");
    } catch (e) {

    }
    let systemId = this.jwt.getToken("systemId")
    // 准备拼接url
    let url = environment.seekerWebAPI + "function/queryButtonsByUri"
    // 要去掉#，故第一个参数不使用
    if (pathname.length > 1) {
      // 拼接uri
      url = url + "?uri=";
      for (let index = 1; index < pathname.length; index++) {
        url = url + "/" + pathname[index]
      }
    }
    // 拼接系统ID参数
    url = url + "&systemId=" + systemId;
    this.http.Post(url, {}).subscribe(data => {
      if (data.code == '200') {
        data.data.forEach((element) => {
          if (
            this.toolbarArr[0].filter((item) => item == element.functionCode)
              .length > 0
          ) {
            this.toolbar[0].push({
              status: true,
              functionCode: element.functionCode,
              functionName: element.functionName,
              icon: element.icon,
              children: [],
            });
          }
          if (
            this.toolbarArr[1].filter((item) => item == element.functionCode)
              .length > 0
          ) {
            this.toolbar[1].push({
              status: true,
              functionCode: element.functionCode,
              functionName: element.functionName,
              icon: element.icon,
              children: [],
            });
          }
        });
      } else {
        this.box.waring('当前用户按钮组权限获取失败！');
      }
    });
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.handleSelectClick();
    }
  }

  // 查询按钮方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  //获取数据
  getData() {
    this.isLoading = true;
    let keyword = $.trim(this.keyword);
    let params = {
      current: this.pageBase.current,
      size: this.pageBase.size,
      name: keyword,
    }
    this.kmsService.queryRdfName(params).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.pageBase = data.data;
          this.datas = data.data.records;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 按钮点击事件
  handleOperationClick(event) {
    switch (event) {
      case "S28_MA0804": this.handleSelectModel(event); break;  // 选择模型
      case "S28_MA0805": this.handleSelectModel(event); break;  // 选择模型
      case "S28_MA0806": this.handleSelectModel(event); break;  // 选择模型
    }
  }

  /**
  * 点击td中的按钮
  * @ignore
  */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 实体命名
    if (type == 'S28_MA0801') {
      this.operationType = type;
      this.batchData = JSON.parse(JSON.stringify(data));
      this.batchModal.toggle();
    }else if(type == 'S28_MA0802'){
      let param = { "selectedData": data };
      this.create.createModal(SetAttrsComponent, param, this.getData.bind(this));
    }else{
      let param = { "selectedData": data };
      this.create.createModal(GetInstanceComponent, param, this.getData.bind(this));
    }
  }

  // 选择模型
  handleSelectModel(type) {
    this.operationType = type;
    this.batchData = {};
    this.batchModal.toggle();
    if (type == 'S28_MA0804') {
      this.modelName = 'ernie-3.0-medium-zh（BiGRU+CRF）';
    } else if (type == 'S28_MA0805') {
      this.modelName = 'swht-entity-alignment-1.0';
    } else {
      this.modelName = 'bert-wwm-chinese（NPTag+UIE）';
    }
  }

  // 表格选中行数据
  handleSelectData(event) {
    //获取当前选中的所有数据
    this.selectedData = event;
    //设置表格按钮组状态
    this.swtable.toolbarAllEnable();
    if (this.selectedData.length == 0) {
      // this.swtable.toolbarDisable("delete");
    };
  }

  // 表格分页点击方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 重置数据
  handleReloadClick() {
    this.keyword = '';
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  onSubmit() {
    if (this.operationType !== 'S28_MA0801') {
      this.box.success('操作成功！');
      this.cancelSubmit();
    } else {
      if (!this.batchData.conceptId) {
        this.box.info('请选择所属概念！');
        return;
      }
      // 保存词条信息
      this.kmsService.updateMaterialRdfs([this.batchData]).subscribe(
        res => {
          if(res.code == '200'){
            this.box.success('操作成功!');
            this.cancelSubmit();
            this.getData();
          }else{
            this.box.success('操作失败!');
          }
        }
      )
    }
  }

  // 取消保存操作
  cancelSubmit() {
    this.operationType = '';
    this.batchData = {};
    this.batchModal.toggle();
  }

  // 查询概念树数据
  getOnlogyTreePageList() {
    this.kmsService.getConceptTreeData({}).subscribe(
      data => {
        if (data.code == 200) {
          if (!data.data) {
            this.ontologyTreeDatas = [];
          }
          this.ontologyTreeDatas = data.data;
          this.readonlySelfIds = ['0'];
          // 获取不可选择的概念树节点
          this.ontologyTreeDatas.forEach(item => {
            if (this.ontologyTreeDatas.filter(item1 => item1.pid == item.id).length > 0) {
              this.readonlySelfIds.push(item.id);
            }
          })
        }
      }
    );
  }

  // 概念下拉选择事件
  handleConceptChange(event) {
    this.batchData.conceptName = event.text;
  }
}


